import axios from 'axios';

import { ResponseObj } from '../../../back/src/types';
import { Exame } from '../../../back/src/entity/Exame';

const exames = async (): Promise<ResponseObj<Exame[]>> => {
  const res = await axios.get<ResponseObj<Exame[]>>('exames');
  return res.data;
};

export default {
  exames,
};
